module.exports = __webpack_public_path__ + "img/img586.791b6333.png";